import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe, TranslateDirective],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {

  @Input() items: SidebarItem[] = []; // Lista de elementos para el sidebar
  @Input() subItems: SidebarItem[] = []; // Lista de elementos para el sidebar

}

interface SidebarItem {
  baseURL: string;
  name: string;
  url: string;
}